import PT from 'prop-types';
import { Pill, enums, utils as u } from 'edrolo-ui';
import { SPICINESS_LEVEL } from 'edrolo/domains/exams';
import { HotPepper } from '../Icons';

export const SpicinessLevel = ({ spiciness }) => {
  return (
    <Pill variant={enums.PillVariant.OUTLINE} color={enums.ColorTheme.PRIMARY}>
      {Array.from({ length: spiciness }, (_, i) => (
        <HotPepper key={i} />
      ))}
      <span className={u.ml2}>{SPICINESS_LEVEL[spiciness]}</span>
    </Pill>
  );
};

SpicinessLevel.propTypes = {
  spiciness: PT.number,
};
